import(/* webpackMode: "eager" */ "/vercel/path0/components/SolutionIndex.js")